// @ts-nocheck FIXME
import ActionModal from '@legacy-components/react/V5/Common/ActionModal';
import PropTypes from 'prop-types';

const DisconnectEventSessionFromZoomModal = (props) => {
  return (
    <ActionModal
      headlineText="Disconnect Event Session from Zoom?"
      close={props.close}
      spaceFromTop={50}
    >
      <div className="v5__body-copy edit-event__modal-row">
        You will not be able to reconnect{' '}
        <span className="bold">{props.sessionName}</span> to Zoom once it has
        been disconnected.
      </div>
      <div className="edit-event__modal-btn-row">
        <button className="v5__btn v5__btn--red" onClick={props.confirm}>
          Disconnect
        </button>
      </div>
    </ActionModal>
  );
};

DisconnectEventSessionFromZoomModal.propTypes = {
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  sessionName: PropTypes.string.isRequired,
};

export default DisconnectEventSessionFromZoomModal;
